import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/app/store";
import { fetchDomains } from "@/features/data-hub/model/domainsSlice";

export function useDomains(options?: { enabled?: boolean }) {
  const enabled = options?.enabled ?? true;
  const dispatch = useAppDispatch();
  const { status, domains } = useAppSelector((s) => s.domains);

  useEffect(() => {
    if (enabled) {
      void dispatch(fetchDomains());
    }
  }, [dispatch, enabled]);

  return { status, domains };
}
